module.exports = __webpack_public_path__ + "img/20m.e18ca0cd.jpg";